// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".body{\n  background-image: url(\"https://cdn.ethicaljournalismnetwork.org/wp-content/uploads/2020/03/fusion-medical-animation-rnr8D3FNUNY-unsplash.jpg\");\n}\n", "",{"version":3,"sources":["styles.css"],"names":[],"mappings":"AAAA;EACE,8IAA8I;AAChJ","file":"styles.css","sourcesContent":[".body{\n  background-image: url(\"https://cdn.ethicaljournalismnetwork.org/wp-content/uploads/2020/03/fusion-medical-animation-rnr8D3FNUNY-unsplash.jpg\");\n}\n"]}]);
// Exports
module.exports = exports;
